var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    color: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 12.089V9.236c0-1.944 0-2.916-.586-3.52S19.886 5.112 18 5.112h-2.079c-.917 0-.925-.002-1.75-.416l-3.331-1.67c-1.391-.698-2.087-1.047-2.828-1.023S6.6 2.421 5.253 3.208l-1.227.719c-.989.578-1.483.867-1.754 1.348C2 5.756 2 6.342 2 7.513v8.236c0 1.539 0 2.309.342 2.737c.228.285.547.476.9.54c.53.095 1.18-.284 2.478-1.044c.882-.516 1.73-1.052 2.785-.907c.884.122 1.705.681 2.495 1.077M8 2.002v15.034m7-12.027v6.013"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.107 20.175l1.845 1.823m-.783-4.36a3.56 3.56 0 1 1-7.121.001a3.56 3.56 0 0 1 7.121 0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassage);
export default __webpack_public_path__ + "static/media/passage.d9afd8e1721bcba521f1a229f51c6ee6.svg";
export { ForwardRef as ReactComponent };